module.exports = __webpack_public_path__ + "media/images/common/logo_coopgifu-cc6138dac98adf5f0df27756e5e18255.png";